import React from 'react';
import { isRequired, isEmail } from '../validations';

export const passwordsDifferent = (password, passwordConfirmation) => {
  if (passwordConfirmation && password) {
    return passwordConfirmation !== password;
  }
  return false;
};

export const renderFrontEndError = (validationError, msg) => {
  if (validationError && validationError[msg]) {
    return (
      <span className="error">{validationError[msg]}</span>
    );
  }
  return false;
};

export const allInputsValid = (fieldsToValidate = [], state = {}) => {
  const validationError = {};

  fieldsToValidate.forEach((field) => {
    const key = field.id;
    const name = state[key];
    const validateRequired = field.hasAttribute('is-required');
    const validateEmail = field.hasAttribute('is-email');

    if (validateEmail) {
      validationError[key] = isRequired(name) || isEmail(name);
    } else if (validateRequired) {
      validationError[key] = isRequired(name);
    }
  });

  return validationError;
};

export const isIndividualInputValid = (target, controlledFieldValue) => {
  const key = target.id;

  const validateRequired = target.hasAttribute('is-required');
  const validateEmail = target.hasAttribute('is-email');

  const validationError = {};

  if (validateEmail) {
    validationError[key] = isRequired(controlledFieldValue) || isEmail(controlledFieldValue);
  } else if (validateRequired) {
    validationError[key] = isRequired(controlledFieldValue);
  }

  return validationError;
};

export const renderServerErrorMsg = (error, loading) => {
  if (error && !loading) {
    if (typeof error === 'object') {
      let a = [];
      for(let i in error) {
        a.push(<li key={`error-${i}`}>{`${i} ${error[i]}`}</li>)
      }

      return (
        <ul className="alert-danger center">
          {a}
        </ul>
      );
    }
    return (
      <p className="alert-danger center">{error}</p>
    );
  }
  return null;
};

export default {
  passwordsDifferent,
  renderServerErrorMsg,
  isIndividualInputValid,
};
